import { StatsElementFilterInternalName } from '../../../../enums/StatsElementGridFilterName';

export const statsElementFilterInternalDefaultFilters: StatsElementFilterInternalName[] = [
  StatsElementFilterInternalName.NoFilter,
  StatsElementFilterInternalName.Default,
];
